import React, { useContext } from "react";
import { motion } from "framer-motion";
import { ThemeContext } from "../../hooks/ThemeContext";

const services = [
  {
    id: "tech",
    title: "Pôle Tech - VPS & Hébergement",
    desc: "Hébergement sécurisé, anti-DDoS, sauvegardes automatiques et gestion sur-mesure.",
  },
  {
    id: "crea",
    title: "Pôle Créatif - Branding & Design",
    desc: "Identité visuelle, logos, chartes et assets pour booster votre image.",
  },
  {
    id: "influence",
    title: "Pôle Influence - TikTok Growth",
    desc: "Stratégie créative, contenus viraux et gestion de campagnes.",
  },
  {
    id: "security",
    title: "Sécurité & Monitoring",
    desc: "Surveillance 24/7, alerting, audits et hardening des serveurs.",
  },
  {
    id: "content",
    title: "Création de Contenu",
    desc: "Vidéos, motion, visuels et community management pour conversion.",
  },
  {
    id: "analytics",
    title: "Analytics & Reporting",
    desc: "Dashboards, tracking & optimisation des performances.",
  },
];

const GroupedProducts = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className={`py-16 ${isDark ? 'bg-gradient-to-r from-[#0f1114] via-rose-900/5 to-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`.trim()}>
      <div className="max-w-7xl mx-auto px-4">
        <h2 className={`text-4xl font-semibold mb-8 text-center ${isDark ? 'text-white' : 'text-gray-800'}`}>Nos Services Populaires</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <motion.div
              key={s.id}
              whileHover={{ y: -6 }}
              className={`${isDark ? 'bg-[#0b0b0c] border border-white/8 hover:border-rose-500/30' : 'bg-white/95 shadow-md border border-gray-100'} rounded-xl p-6 transition`}
            >
              <h3 className={`text-xl font-semibold mb-2 ${isDark ? 'text-rose-300' : 'text-rose-600'}`}>{s.title}</h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4 text-sm`}>{s.desc}</p>
              <div className="flex items-center justify-between">
                <a href={`/services#${s.id}`} className={`${isDark ? 'bg-rose-600 hover:bg-rose-700' : 'bg-rose-600 hover:bg-rose-700'} text-white px-4 py-2 rounded-md transition`}>En savoir plus</a>
                <a href="/contact" className={`${isDark ? "text-gray-300" : "text-gray-700"} text-sm hover:text-rose-400`}>Demander un devis →</a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GroupedProducts;
